import { escapeRegExp } from 'lodash-es';

const TRACKING_HOSTS = [
  'adroll.com',
  'ads.linkedin.com',
  'analytics.tiktok.com',
  'bat.bing.com',
  'clarity.ms',
  'doubleclick.net',
  'ecs.us-east-1.on.aws', // Endpoint blocked by our CSP, fired by a tag in the GTM container
  'facebook.com',
  'facebook.net',
  'google-analytics.com',
  'googleadservices.com',
  'googlesyndication.com',
  'googletagmanager.com',
  'licdn.com',
  'pinimg.com',
  'pinterest.com',
  'segment.com',
  'segment.io',
  'taboola.com',
];

/**
 * Requests that Datadog RUM ignores when deciding that a page has finished loading.
 *
 * A view's loading time ends after 100ms without network requests or DOM mutations, so the cascade of ad and analytics
 * pixels fired by GTM and Segment would otherwise keep extending it long after the page is usable.
 *
 * This is a blacklist on purpose: third parties that render visible UI (Trustpilot, Google Maps, YouTube) and reCAPTCHA
 * still count. New pixels added to the GTM container need to be added here.
 */
export const EXCLUDED_ACTIVITY_URLS: RegExp[] = [
  // The host or any of its subdomains, so a tracker URL in a query string or a lookalike host does not match
  new RegExp(`^https://([\\w-]+\\.)*(${TRACKING_HOSTS.map(escapeRegExp).join('|')})([/:?]|$)`),
  // Google ad conversion pixels. A host match would also exclude reCAPTCHA on www.google.com
  /^https:\/\/www\.google\.[a-z.]+\/(pagead|ccm|rmkt)\//,
  /^https:\/\/[^/?#]+\/_vercel\/(speed-)?insights\//,
];
